import { FaceImage } from '@app-pages/models/face-image';

export class CardDetails {
  constructor(
    public engravedId?: string,
    public ref?: string,
    public image?: FaceImage
  ) {}
}
